module.exports = __webpack_public_path__ + "static/media/facebook.1b2350cd.svg";